import { create } from "zustand"
import { persist, createJSONStorage } from "zustand/middleware"
import AsyncStorage from "@react-native-async-storage/async-storage"
import { UpcomingExam } from "../../types/exams"

interface ExamState {
  selectedExamId: UpcomingExam["id"] | null
  setSelectedExamId: (id: UpcomingExam["id"]) => void
  getCurrentExam: (exams: UpcomingExam[]) => UpcomingExam | null
  clearExam: () => void
}

export const useExamStore = create<ExamState>()(
  persist(
    (set, get) => ({
      selectedExamId: null,
      setSelectedExamId: (id) => set({ selectedExamId: id }),
      getCurrentExam: (exams) => {
        const { selectedExamId } = get()

        return exams.find((e) => e.id === selectedExamId) || exams[0] || null
      },
      clearExam: () => set({ selectedExamId: null }),
    }),
    { name: "exam-storage", storage: createJSONStorage(() => AsyncStorage) },
  ),
)
